module.exports = __webpack_public_path__ + "img/Mainz-05.f68175e2.png";